import { observer } from 'mobx-react-lite'
import { EmptyState, Typography } from 'shared/ui'
import { getCDNAssetURL } from 'shared/lib'
import tagsPreviewImg from 'shared/assets/images/tags/tags_preview.png'
import { LINK_TAGS_GUIDE } from 'shared/constants/links'
import {
  CreateTagsButton,
  GuideTagsButton,
} from 'pages/settings/pages/tags/ui/TagsAction/TagsAction'
import styles from './styles.module.scss'

export const TagsEmpty = observer(() => {
  return (
    <section className={styles.empty}>
      <EmptyState
        title={
          <span className={styles.title}>
            <a
              href={LINK_TAGS_GUIDE}
              rel='noreferrer'
              target='_blank'
              className={styles.titlePreview}
            >
              <img alt='Tag preview' src={getCDNAssetURL(tagsPreviewImg)} />
            </a>
            <Typography variant={'heading-lg'} ariaLabel='Create your first tag'>
              Create your first tag
            </Typography>
          </span>
        }
        actions={
          <div className={styles.actions}>
            <CreateTagsButton className={styles.actionButton} />
            <GuideTagsButton className={styles.actionButton} />
          </div>
        }
        text={'Group your contacts and send targeted, automated messages with ease.'}
        typographyProps={{
          variant: 'body-lg-regular',
          ariaLabel: 'TagsText',
          marginTop: '4px',
        }}
        boxProps={{
          gap: '20px',
          width: 'unset',
          height: 'unset',
          textAlign: 'center',
        }}
        noIcon
      />
    </section>
  )
})
